import { SvgIconProps } from './types';

export const SvgIcon = ({ icon }: SvgIconProps): JSX.Element => (
  <svg className={`o-icon o-icon-${icon}`} focusable='false'>
    <use xlinkHref={`../../assets-v2/images/symbol-defs.svg#o-icon-${icon}`} />
  </svg>
);
